import Vue from 'vue'
import Router from 'vue-router'
import gw_detail from '@/pages/gw/detail'
import gw_index from '@/pages/gw/index'
import gw_list from '@/pages/gw/list'
import wg_index from '@/pages/wg/index'
import wg_next from '@/pages/wg/next'
import my_rank from '@/pages/vip/my_rank'
import rank_recommend from '@/pages/vip/rank_recommend'
import score_detail from '@/pages/vip/score_detail'
import downLoad from '@/pages/downLoad/index2'
import live_detail from '@/pages/qf/live_detail'
import live_video_detail from '@/pages/qf/live_video_detail'
import news_detail from '@/pages/qf/news_detail'
import video_detail from '@/pages/qf/video_detail'
import picture_detail from '@/pages/qf/picture_detail'
import report from '@/pages/iapc/report'
import survey from '@/pages/iapc/survey'
import businesses_login from '@/pages/whk/businesses_login'
import product_list from '@/pages/whk/product_list'
import user_login from '@/pages/whk/user_login'
import write_off from '@/pages/whk/write_off'
import qr_write_off from '@/pages/whk/qr_write_off'
import cs_product_list from '@/pages/credit_score/product_list'
import wz_index from '@/pages/wz/wz_index'
import selectInfo from '@/pages/fy/selectInfo2'
import watermark from '@/pages/watermark/watermark'
import partyDetails from '@/pages/party/party_details'
Vue.use(Router)

export default new Router({
  routes: [
    /*{
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },*/

    {
      path: '/gw/detail',
      name: 'gw_detail',
      component: gw_detail
    },
    {
      path: '/gw/index',
      name: 'gw_index',
      component: gw_index
    },
    {
      path: '/gw/list',
      name: 'gw_list',
      component: gw_list
    },

    {
        path: '/wg/wg_index',
      name: 'wg_index',
      component: wg_index
    },
    {
      path: '/wg/wg_next',
      name: 'wg_next',
      component: wg_next
    },
    {
      path: '/vip/my_rank',
      name: 'my_rank',
      component: my_rank
    },
    {
      path: '/vip/rank_recommend',
      name: 'rank_recommend',
      component: rank_recommend
    },
    {
      path: '/vip/score_detail',
      name: 'score_detail',
      component: score_detail
    },
    {
      path: '/downLoad/index',
      name: 'index',
      component: downLoad
    },
    {
      path: '/qf/live_detail',
      name: 'live_detail',
      component: live_detail
    },
    {
      path: '/qf/live_video_detail',
      name: 'live_video_detail',
      component: live_video_detail
    },

    {
      path: '/qf/news_detail',
      name: 'news_detail',
      component: news_detail
    },
    {
      path: '/qf/video_detail',
      name: 'video_detail',
      component: video_detail
    },
    {
      path: '/qf/picture_detail',
      name: 'picture_detail',
      component: picture_detail
    },
    {
      path: '/iapc/report',
      name: 'report',
      component: report
    },
    {
      path: '/iapc/survey',
      name: 'survey',
      component: survey
    },
    {
      path: '/whk/businesses',
      name: 'businesses',
      component: businesses_login
    },
    {
      path: '/whk/productList',
      name: 'productList',
      component: product_list
    },
    {
      path: '/whk/userLogin',
      name: 'userLogin',
      component: user_login
    },
    {
      path: '/whk/writeOff',
      name: 'writeOff',
      component: write_off
    },
    {
      path: '/whk/qr_writeOff',
      name: 'qr_writeOff',
      component: qr_write_off
    },
    {
      path: '/cs/product_list',
      name: 'cs_product_list',
      component: cs_product_list
    },
    {
      path: '/serve/wz',
      name: 'wz_index',
      component: wz_index
    },
    {
      path: '/serve/select',
      name: 'selectInfo',
      component: selectInfo
    },
    {
      path: '/serve/watermark',
      name: 'watermark',
      component: watermark
    },

    {
      path: '/news/party_details',
      name: 'partyDetails',
      component: partyDetails
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js